module.exports = __webpack_public_path__ + "static/media/ystadvapen.b1db9481.png";